import { couponListHandler, redeemCodeHandler } from '@api/coupon-api'
import { Message } from 'element-ui'
import router from '../../router'
import i18n from '@/helper/i18n'

const coupon = {
    namespaced: true,
    state: {
        couponList: null,
        couponDetail: null,
        couponCode: null,
        couponCodeView: false
    },
    getters: {
        couponList(state) {
            return state.couponList
        },
        couponDetail(state) {
            return state.couponDetail
        },
        couponCode(state) {
            return state.couponCode
        },
        couponCodeView(state) {
            return state.couponCodeView
        },
    },
    mutations: {
        SET_COUPON_LIST(state, couponList) {
            state.couponList = couponList
        },
        SET_COUPON_DETAIL(state, couponDetail) {
            state.couponDetail = couponDetail
        },
        SET_COUPON_CODE(state, couponCode) {
            state.couponCode = couponCode
        },
        SET_COUPON_CODE_VIEW(state, couponCodeView) {
            state.couponCodeView = couponCodeView
        },
    },
    actions: {
        fetchCouponList: async ({ commit }, branchUUID) => {
            return await couponListHandler(branchUUID)
                .then((response) => {
                    if(response.data.data != null){
                        commit('SET_COUPON_LIST', response.data.data.promotions)
                        return response.data.data.promotions
                    }
                    throw 'Not Found coupon info'
                }).catch(async (error) => {
                    await commit('SET_COUPON_LIST', null);
                    if (error.response) {
                        if (error.response.data.code == 400 && error.response.data.responseCode == "B02") {
                            throw { isDisableCrm: true };
                        } else {
                            throw error;
                        }
                    } else {
                        throw error;
                    }
                });
        },
        setCouponDetail: async ({ commit }, couponDetail) => {
            await commit('SET_COUPON_DETAIL', couponDetail)
        },
        redeemCoupon: async ({ commit }, payload) => {
            const result = await redeemCodeHandler(payload)
                .then((response) => {
                    commit('SET_COUPON_CODE_VIEW', true)
                    commit('SET_COUPON_CODE', response.data.data);
                    router.push({ name: 'CouponCode' });
                    return response.data.data;
                }).catch((error) => {
                    Message.error({ duration: 2000, message: i18n.t('store.error-reward') });
                })
        }
    }
}

export default coupon
